// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"241":"08affad47600c57fb4c1","825":"a40de33b270c9cbe283b"}[chunkId] + ".js";
};